export default "__VITE_ASSET__DhqrB4Eu__"